import { getOrgData } from "entities/api/_request";
import { lazy } from "react";
import { Outlet, Route, Routes, useParams } from "react-router-dom";
import { DataLoader } from "shared/UI/data-loader";

const OrdersListPage = lazy(() => import("pages/list"));
const OrderOverviewPage = lazy(() => import("pages/overview"));
const OrderCreatePage = lazy(() => import("pages/create"));
const OrderInvoicePage = lazy(() => import("pages/invoice"));

const SchedulePage = lazy(() => import("pages/schedule"));

const OrgLoader = () => {
    const {org} = useParams()

    console.log(org)

    return (
        <DataLoader request={() => getOrgData(org!)}>
            {({data}) => (
                <>
                    {/* {data && <Outlet/>} */}
                </>
            )}
        </DataLoader>
    )
}

export const Routing = () => {
    return (
        <Routes>
            <Route path=":org/*" element={<OrgLoader/>}>
                <Route index element={<OrdersListPage/>} />
                <Route path="orders/overview/:orderId" element={<OrderOverviewPage/>} />

                <Route path="orders/create" element={<OrderCreatePage/>} />
                <Route path="orders/create/:orderId" element={<OrderCreatePage/>} />

                <Route path="orders/invoice" element={<OrderInvoicePage/>} />
                
                <Route path='*' element={<OrdersListPage/>} />
            </Route>
            <Route path="schedule" element={<SchedulePage/>} />
        </Routes>
    );
};
